import React from 'react';
import Button from '@material-ui/core/Button';
import '../../assets/css/Order.css'
import moment from 'moment';
import { withStyles } from '@material-ui/core/styles';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid'
import Card from "../Card/Card.jsx";
import ReactTable from 'react-table-v6'
import CondensedNotes from "../Common/CondensedNotes.jsx";

const useStyles = (theme) => ({
    root: {
        '& > *': {
            margin: theme.spacing(1),
            marginBottom: theme.spacing(5)
        }
    },
    rootButton: {
        '& > *': {
            margin: theme.spacing(1),
            marginTop: theme.spacing(-1.8),
            marginLeft: theme.spacing(1.5)
        }
    },
    paper: {
        backgroundColor: "red"
    },
    margin: {
        // margin: theme.spacing(1),
        marginRight: theme.spacing(10)
    },
    withoutLabel: {
        marginTop: theme.spacing(2),
    },
    textField: {
        width: '16vw',
    },

});

const headerStyle = {
    border: 'none', 
    color: '#AAAAAA', 
    fontFamily: "Roboto-Bold", 
    width: '200px'
};

const bodyStyle = {
    fontFamily: 'Roboto-Regular', 
    color: '#888888', 
    fontWeight: 'bolder'
};

class Detailstable extends React.PureComponent {
    
    state = {
        order: {},
        notesData: []
    }

    componentDidUpdate() {
        this.setState({ order: this.props.order, })
    }
      
    render() {
        const { classes } = this.props;
        const { order } = this.state;
        const data = {
            order_date: order?.order_details?.order_date ? moment(order?.order_details?.order_date).format('MM/DD/YYYY') : "N/A",
            due_date: order?.order_details?.due_date ? moment(order?.order_details?.due_date).format('MM/DD/YYYY') : "N/A",
            hold_date: order?.logs?.[0]?.order_status.filter((order_stat ,i) => order_stat.status === "Hold")[0]?.done_on,
            completed_date: order?.logs?.[0]?.order_status.filter((order_stat ,i) => order_stat.status === "Completed")[0]?.done_on,
        }
        const notesData = order?.order_details?.notes?.order_notes.map(note => {
            return {
                id: moment(note.done_on).format('MM/DD/YYYY hh:mmA'),
                name: note.vendor_name,
                data: note.notes,
            };
        })
           
        return (
            <div style={{ backgroundColor: 'white' }}>
                <Grid container justify="center">
                    <Grid item xs={12} md={6}>
                        <Card style={{ boxShadow: '0px 0px 5px 0px #d6d6d6'  }}>
                                <div className={classes.rootButton}>
                                    <Button variant="contained" style={{ boxShadow: '0px 3px 5px -2px #AAAAAA',outline: 'none', color: 'white', height: '50px', width: '170px', fontFamily: 'Roboto-Bold', backgroundColor: '#04AB23', textTransform: 'none' }} disabled>
                                     Order Info
                                    </Button>
                                </div>
                                <CardContent>
                                    <Grid container>
                                        <Grid item xs={6}>
                                            <p style={headerStyle}>Order Date</p>
                                            <p style={headerStyle}>Due Date</p>
                                            <p style={headerStyle}>Hold Date</p>
                                            <p style={headerStyle}>Completed Date</p>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <p style={bodyStyle}>{data.order_date}</p>
                                            <p style={bodyStyle}>{data.due_date}</p>
                                            <p style={bodyStyle}>{data.hold_date !== undefined ? moment(data.hold_date).format('MM/DD/YYYY') : "N/A"}</p>
                                            <p style={bodyStyle}>{data.completed_date !== undefined ? moment(data.completed_date).format('MM/DD/YYYY') : "N/A"}</p>
                                        </Grid>
                                    </Grid>
                                </CardContent>
                            </Card>
                            <Card>
                            <div className={classes.rootButton}>
                                    <Button variant="contained" style={{ boxShadow: '0px 3px 5px -2px #AAAAAA',outline: 'none', color: 'white', height: '50px', width: '170px', fontFamily: 'Roboto-Bold', backgroundColor: '#04AB23', textTransform: 'none' }} disabled>
                                     Notes
                                    </Button>
                                    <CardContent>
                                         <ReactTable
                                        NoDataComponent={() => <p style={{textAlign: "center"}}>No Notes Available</p>}
                                        data={notesData}
                                        columns={[
                                            {
                                                accessor: 'id',
                                                Header: 'Added On',
                                                style: { fontFamily: 'Roboto-Bold', border: 'none', color: '#999', textAlign: 'center' },
                                                headerStyle: { border: 'none',  textAlign: 'center' },
                                                width: 180
                                            },
                                            {
                                                accessor: 'name',
                                                Header: 'User Name',
                                                headerStyle: { border: 'none', textAlign: 'center' },
                                                style: { fontFamily: 'Roboto-Bold', border: 'none', color: '#666', textAlign: 'center' },
                                                width: 180
                                            },
                                            {
                                                accessor: 'data',
                                                Header: 'Content',
                                                Cell: row => <CondensedNotes row={row} slicedIndex={100} />,
                                                headerStyle: { border: 'none', textAlign: 'left' },
                                                style: { fontFamily: 'Roboto-Bold', border: 'none', color: '#333', whiteSpace: 'normal' }
                                            },
                                        ]}
                                        showPaginationBottom={false}
                                        defaultPageSize={10}
                                        minRows={0}
                                        sortable={false}
                                        style={{border: 'none'}}
                                        getTrGroupProps={() => {
                                            return {
                                                style: {
                                                    border: "0px",
                                                    backgroundColor: "white"

                                                }
                                            }
                                        }}
                                    />
                                    </CardContent>
                                </div>
                            </Card>
                    </Grid>
                </Grid>
            </div>
        )
    }
}
export default withStyles(useStyles, { withTheme: true })(Detailstable)
